import { ExpressionStatus, ExpressionType } from 'client/Security/data/Condition';

class ConditionDevice {
  constructor(initialData = { status: ExpressionStatus.include }) {
    this.status = initialData.status;
  }

  static fromApi(apiResource) {
    return {
      type: ExpressionType.device,
      status: apiResource.deviceManaged
        ? ExpressionStatus.include
        : ExpressionStatus.exclude,
    };
  }

  toApi() {
    return {
      deviceManaged: this.status === ExpressionStatus.include,
    };
  }

  toConditionRow() {
    return {
      condition: ExpressionType.device,
      status: this.status,
    };
  }
}

export default ConditionDevice;
